<ng-container *transloco="let t">
  <pxw-cart-view-shell
    [columns]="columns()"
    [readOnly]="readOnly()"
    [stickyCategoryHeaders]="stickyCategoryHeaders()"
  >
    @for (section of sections(); track section.key) {
      <pxw-cart-category-shell
        [displayHeader]="section.header !== null"
        [headerLabel]="getHeaderLabel(section.header)"
        [productCount]="section.productGroups.length"
        [readOnly]="readOnly()"
        [stickyHeader]="stickyCategoryHeaders()"
        [isCategoryAvailable]="isCategoryAvailable(section.categoryId)"
        [unavailableAlertText]="t('categoryAvailability.productsNotAvailable')"
        [checkScheduleLabel]="t('categoryAvailability.checkSchedule')"
        (openAvailability)="section.categoryId && onOpenAvailability(section.categoryId)"
      >
        @for (productGroup of section.productGroups; track productGroup.productId) {
          @let categoryAvailable = isCategoryAvailable(productGroup.categoryId);
          @let product = getProductFromGroup(productGroup);
          @let promotions = getPromotions(productGroup.productId);
          @let savings = getSavings(productGroup.productId);
          <pxw-cart-product-group-shell
            [readOnly]="readOnly()"
            [isCategoryAvailable]="categoryAvailable"
            [promoTagLabels]="buildPromoTagLabels(promotions, t)"
            [formattedSavings]="savings > 0 ? formatCurrency(savings) : undefined"
            [subtotalLabel]="t('cartView.productSubtotal')"
            [formattedSubtotal]="
              shouldDisplaySubtotal(productGroup, savings)
                ? formatCurrency(productGroup.subtotal - savings)
                : undefined
            "
          >
            @if (product) {
              <pxw-cart-product-header
                productHeader
                [productName]="product | propInSelectedLanguage: 'name' : selectedLanguage() : true"
                [productImage]="getProductFirstImage(product)"
                [productSku]="product.sku"
                [displaySku]="displaySku()"
                [displayImage]="displayImage()"
                [readOnly]="readOnly()"
                [isCategoryAvailable]="categoryAvailable"
                [isProductUnavailable]="isProductGroupHidden(productGroup)"
                [withoutImageLabel]="t('product.withoutImage')"
                [notAvailableLabel]="t('categoryAvailability.notAvailable')"
                [productNotAvailableLabel]="t('cartView.productNotAvailable')"
                [warningNote]="restrictionLabelByProductId().get(product.id)"
                (edit)="edit.emit(productGroup.orderItems[0].cartItem)"
                (removeAll)="onRemoveProductGroup(productGroup)"
                (openAvailability)="onOpenAvailability(productGroup.categoryId)"
              />
            }
            @for (orderItem of productGroup.orderItems; track orderItem.cartItem.id) {
              @let productIsOutOfStock =
                (orderItem.cartItem.product | pxwStockIsOutOfStock | async) ?? false;
              <pxw-cart-order-item
                [cartItem]="orderItem.cartItem"
                [readOnly]="readOnly()"
                [isOutOfStock]="productIsOutOfStock"
                [isCategoryAvailable]="categoryAvailable"
                [hasOptions]="hasOptions(orderItem)"
                [availableOptionsLabel]="
                  availableOptionsLabelByProductId().get(orderItem.cartItem.product.id) ?? ''
                "
                [observations]="orderItem.cartItem.observations"
                [displaySelector]="displayItemSelector()"
                [selected]="isCartItemSelected(orderItem.cartItem.id)"
                (edit)="edit.emit($event)"
                (remove)="remove.emit($event)"
                (selectedChange)="
                  itemSelectedChange.emit({ cartItem: orderItem.cartItem, selected: $event })
                "
              >
                @for (row of getRows(orderItem); track $index; let isFirst = $first) {
                  <pxw-cart-order-item-row
                    [quantity]="row.quantity"
                    [presentationLabel]="
                      row.presentationSource!
                        | propInSelectedLanguage: 'name' : selectedLanguage() : true
                    "
                    [presentationSku]="row.presentationSource ? row.sku : undefined"
                    [displaySku]="displaySku()"
                    [totalWithoutDiscount]="row.totalWithoutDiscount"
                    [total]="row.total"
                    [readOnly]="readOnly()"
                    [availableStock]="(row.itemId | pxwStockInfo | async)?.availableStock"
                    [stockWarningLabel]="
                      categoryAvailable
                        ? ((row.itemId | pxwStockWarning | async) ?? undefined)
                        : undefined
                    "
                    [showRemove]="isFirst"
                    [isOutOfStock]="productIsOutOfStock"
                    [isCategoryAvailable]="categoryAvailable"
                    [upsellHint]="getRowUpsellHint(orderItem.cartItem.id, row)"
                    [removeLabel]="
                      t('cartView.removeItem', {
                        name:
                          (orderItem.cartItem.product
                          | propInSelectedLanguage: 'name' : selectedLanguage() : true),
                      })
                    "
                    (qtyChange)="onRowQtyChange(orderItem.cartItem, row, $event)"
                    (remove)="remove.emit(orderItem.cartItem)"
                  />
                }
                @let multiplier = getOptionMultiplier(orderItem);
                @for (selectedOption of orderItem.cartItem.selectedOptions ?? []; track $index) {
                  <pxw-cart-order-item-option-group
                    [name]="
                      selectedOption.option.name
                        ? (selectedOption.option
                          | propInSelectedLanguage: 'name' : selectedLanguage() : true)
                        : undefined
                    "
                    [readOnly]="readOnly()"
                  >
                    @for (item of selectedOption.items; track $index) {
                      @let optTotal =
                        getOptionItemTotalAmount(selectedOption.option, item, multiplier);
                      <pxw-cart-order-item-option-item
                        [quantity]="getOptionItemQty(selectedOption.option, item, multiplier)"
                        [name]="item | propInSelectedLanguage: 'name' : selectedLanguage() : true"
                        [formattedTotal]="optTotal > 0 ? formatCurrency(optTotal) : undefined"
                        [stockWarningLabel]="
                          categoryAvailable && item.id
                            ? ((item.id | pxwStockWarning | async) ?? undefined)
                            : undefined
                        "
                      />
                    }
                  </pxw-cart-order-item-option-group>
                }
              </pxw-cart-order-item>
            }
          </pxw-cart-product-group-shell>
        }
      </pxw-cart-category-shell>
    }
  </pxw-cart-view-shell>
</ng-container>
